<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <router-link to="/userNotification">
            <input type="button" :value="cancelButton" class="cancel_button" />
          </router-link>
          <input
            type="button"
            :value="addButton"
            class="finish_button"
            @click="showModal = true"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="detail_content">
            <div class="detail_label">
              {{ titleLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('title')"
            />
          </div>
          <div class="detail_content">
            <div class="detail_label">
              {{ messageLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <textarea
              id="message"
              class="detail_input_field message"
              @input="inputAddUpdate('message')"
            ></textarea>
          </div>
          <div class="detail_content">
            <div class="detail_label">
              {{ targetLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <div class="all_label">
              <label>
                <input
                  type="radio"
                  name="target"
                  class="option_radio_button"
                  checked
                  @click="allFlag = true"
                />
                {{ allLabel }}
              </label>
              <label>
                <input
                  type="radio"
                  name="target"
                  class="option_radio_button"
                  @click="allFlag = false"
                />
                {{ postLabel }}
              </label>
            </div>
            <input
              type="button"
              :value="settingPostButton"
              class="setting_post_button"
              :class="{disabled: allFlag}"
              @click="settingPostModal = true"
            />
            <div
              class="post_name"
              v-if="selectedPostList.length > 0 && !allFlag"
              v-for="item in selectedPostList"
              :key="item.postId"
            >
              {{ item.postName }}
            </div>
          </div>
          <div class="detail_content">
            <div class="detail_label">
              {{ startLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <datepicker
              placeholder="Select Date"
              :config="datepicker_config"
              :locale="ja"
              id="start"
              value=""
              @on-change="customFormatter"
              class="notification_datepicker start_date_time"
            >
            </datepicker>
          </div>
          <div class="detail_content">
            <div class="detail_label">
              {{ endLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <datepicker
              placeholder="Select Date"
              :config="datepicker_config"
              :locale="ja"
              id="end"
              value=""
              @on-change="customFormatter"
              class="notification_datepicker start_date_time"
            >
            </datepicker>
          </div>
        </div>
      </div>
      <div class="modal_window" v-if="showModal">
        <addModalWindow @close="stayClose" @add="addUserNotification">
        </addModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
      <div class="modal_window" v-if="settingPostModal">
        <settingPostModalWindow
          :dispItems="posts"
          :selItems="selectItems"
          :from="'userNotificationAdd'"
          @close="closeSettingPostModal"
          @changePost="changePost"
        >
        </settingPostModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import addModalWindow from '../modalWindow/addModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import settingPostModalWindow from '../modalWindow/settingPostModalWindow.vue'
import datepicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import japanese from 'flatpickr/dist/l10n/ja.js'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      addButton: '追加',
      titleLabel: 'タイトル',
      messageLabel: '本文',
      targetLabel: '送信対象',
      allLabel: '全体',
      postLabel: '所属',
      settingPostButton: '所属の設定',
      startLabel: '開始日時',
      endLabel: '終了日時',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      settingPostModal: false,
      allFlag: true,
      selectItems: [],
      selectedPostId: [],
      canselSelectPostId: [],
      selectedPostList: [],
      ja: japanese,
      datepicker_config: {
        dateFormat: 'Y/m/d H:i',
        locale: japanese,
        enableTime: true,
        time_24hr: true,
        defaultHour: 0,
        defaultMinute: 0,
        minuteIncrement: 1
      }
    }
  },
  async created() {
    this.showloadingModal = true
    this.selectedPostId = []
    this.selectedPostList = []
    this.$store.dispatch('userNotification/clearUserNotification')
    try {
      await this.$store.dispatch('userNotification/setPost')
      await this.$store.dispatch('userNotification/setSelectedPost')
    } catch (error) {
      let eventNumber = this.$store.state.error.errorCode.errorCode_730001
      let eventType = 3
      let reason = 'MSGCRC0035 '
      if (error.response) {
        this.failureWord =
          this.errorMsg.MSGCRC0035.name +
          this.errorMsg.MSGCRC0035.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        reason += error.response.status
      } else {
        reason = 'MSGCRC0005'
        eventType = 9
        this.failureWord =
          this.errorMsg.MSGCRC0005.name +
          this.errorMsg.MSGCRC0005.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
      try {
        this.$store.dispatch('masters/writeLog', {
          eventNumber,
          eventType,
          reason
        })
      } catch (error) {}
      this.showFailureModal = true
    }
    this.showloadingModal = false
  },
  components: {
    addModalWindow,
    completeModalWindow,
    loadingModalWindow,
    datepicker,
    settingPostModalWindow
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    posts() {
      return this.$store.state.userNotification.posts
    },
    selectedPosts() {
      return this.$store.state.userNotification.selectedposts
    }
  },
  methods: {
    customFormatter(e) {
      let date = new Date(e)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      return year + '/' + month + '/' + day
    },
    inputAddUpdate(e) {
      this.$store.dispatch('userNotification/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push('/userNotification')
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    closeSettingPostModal(e) {
      this.settingPostModal = false
      this.selectItems = Array.from(this.canselSelectPostId)
    },
    async changePost(e) {
      this.selectedPostList = []
      this.canselSelectPostId = []
      this.selectedPostId = e
      // this.selectedPostIdには所属IDしか持っていないためIDに紐づく情報をthis.selectedPostListに入れる
      for (var i = 0; i < this.selectedPostId.length; i++) {
        for (var j = 0; j < this.selectedPosts.length; j++) {
          if (this.selectedPostId[i] === this.selectedPosts[j]['postId']) {
            let postId = this.selectedPosts[j]['postId']
            let postName = this.selectedPosts[j]['postName']
            let postCode = this.selectedPosts[j]['postCode']
            this.selectedPostList.push({postId, postName, postCode})
            this.canselSelectPostId.push(postId)
          }
        }
      }
      this.selectedPostList.sort(function(a, b) {
        if (a.postCode > b.postCode) {
          return 1
        } else if (a.postCode < b.postCode) {
          return -1
        } else {
          return 0
        }
      })
      this.settingPostModal = false
    },
    async addUserNotification(e) {
      this.showloadingModal = true
      let start = document.getElementById('start').value
      let end = document.getElementById('end').value
      let startDateTime = 0
      let endDateTime = 0
      if (start === '') {
        let eventNumber = this.$store.state.error.errorCode.errorCode_730001
        let eventType = 9
        let reason = 'MSGCRC0328'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.errorMsg.MSGCRC0328.name +
          this.errorMsg.MSGCRC0328.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      if (end === '') {
        let eventNumber = this.$store.state.error.errorCode.errorCode_730001
        let eventType = 9
        let reason = 'MSGCRC0329'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.errorMsg.MSGCRC0329.name +
          this.errorMsg.MSGCRC0329.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      let startDate = new Date(start)
      startDate.setSeconds(0)
      // UnixTimeに変換
      startDateTime = startDate.getTime()

      let endDate = new Date(end)
      endDate.setSeconds(59)
      // UnixTimeに変換
      endDateTime = endDate.getTime()

      if (startDateTime > endDateTime) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_730001
        let eventType = 9
        let reason = 'MSGCRC0330'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.errorMsg.MSGCRC0330.name +
          this.errorMsg.MSGCRC0330.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }

      let allFlag = this.allFlag
      if (!allFlag && this.selectedPostId.length === 0) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_730001
        let eventType = 9
        let reason = 'MSGCRC0327'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.errorMsg.MSGCRC0327.name +
          this.errorMsg.MSGCRC0327.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      this.$store.dispatch('userNotification/inputAddUpdate', {
        name: 'allFlag',
        value: allFlag
      })
      this.$store.dispatch('userNotification/inputAddUpdate', {
        name: 'postIdList',
        value: this.selectedPostId
      })
      this.$store.dispatch('userNotification/inputAddUpdate', {
        name: 'startDateTime',
        value: startDateTime
      })
      this.$store.dispatch('userNotification/inputAddUpdate', {
        name: 'endDateTime',
        value: endDateTime
      })
      try {
        await this.$store.dispatch('userNotification/addUserNotification')
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord = '追加しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_730001
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          switch (errorMessage) {
            case 'MSGCRC0323':
            case 'MSGCRC0324':
            case 'MSGCRC0325':
            case 'MSGCRC0326':
              this.failureWord =
                this.errorMsg[errorMessage].name +
                this.errorMsg[errorMessage].value +
                'エラーコード：{' +
                eventNumber +
                '}'
              break
            default:
              this.failureWord =
                this.errorMsg.MSGCRC0331.name +
                this.errorMsg.MSGCRC0331.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              break
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0331'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0331.name +
            this.errorMsg.MSGCRC0331.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.message {
  resize: vertical;
  min-height: 100px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
.notification_datepicker {
  border: 2px solid #a6c6c5;
  border-radius: 3px;
  padding: 0 0 0 10px;
  height: 30px;
  font-size: 14px;
}
.disabled {
  background-color: #afafaf;
}
</style>



// WEBPACK FOOTER //
// src/components/userNotification/userNotificationAdd.vue